import { useDashboardData } from "../../../context/DashboardContext";
import { AdditionalStatCard } from "../../StatCard";
import type { WidgetComponentProps } from "../types";

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value);
const formatCurrencyAbbreviated = (value: number) => {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(2)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(1)}K`;
  return formatCurrency(value);
};
const formatPercent = (value: number) => `${value.toFixed(1)}%`;
const formatNumber = (value: number) => value.toLocaleString();

type FormatType = "currency" | "currencyAbbreviated" | "percent" | "number";

const formatters: Record<FormatType, (v: number) => string> = {
  currency: formatCurrency,
  currencyAbbreviated: formatCurrencyAbbreviated,
  percent: formatPercent,
  number: formatNumber,
};

export default function AdditionalStatWidget({ config, title }: WidgetComponentProps) {
  const { metrics } = useDashboardData();

  const metricKey = config.metricKey as string;
  const format = (config.format as FormatType) || "currency";
  const description = config.description as string | undefined;

  const value = metrics[metricKey] ?? 0;
  const formatter = formatters[format] || formatCurrency;

  return <AdditionalStatCard label={title} value={formatter(value)} description={description} />;
}
